import vuejs from './dashboard/vuejs.png'

export const images = {
    vuejs
}